export const ALERTS_DRAWER_PARAM = "alerts";
export const ALERTS_DRAWER_OPEN_VALUE = "1";
